import { Box, Button, IconButton, paletteColors, Popover, Typography } from '@evaneos/b2b-ui';
import CalendarMonthOutlinedIcon from '@evaneos/b2b-ui/icons/CalendarMonthOutlined';
import CloseIcon from '@evaneos/b2b-ui/icons/Close';
import { useState } from 'react';

import {
    formatAppointmentButtonLabel,
    formatAppointmentPopoverDate,
    formatAppointmentTimeRange,
} from './appointmentBlock.operations';

type Appointment = {
    startAt: string;
    endAt: string;
};

type Props = {
    appointment?: Appointment | null;
};

export function AppointmentBlock({ appointment }: Readonly<Props>) {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const isOpen = Boolean(anchorEl);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    if (!appointment) {
        return (
            <Button
                variant="outlined"
                startIcon={<CalendarMonthOutlinedIcon />}
                disabled
                data-spec-id="appointment-block"
            >
                {/* @todo translate: appointment.block.no_rdv */}
                Aucun RDV
            </Button>
        );
    }

    return (
        <>
            <Button
                variant="outlined"
                startIcon={<CalendarMonthOutlinedIcon />}
                onClick={handleOpen}
                data-spec-id="appointment-block"
                aria-describedby={isOpen ? 'appointment-popover' : undefined}
                sx={{
                    backgroundColor: paletteColors.blue[100],
                    color: paletteColors.blue[900],
                    borderColor: paletteColors.blue[900],
                    '&:hover': {
                        backgroundColor: paletteColors.blue[200],
                        color: paletteColors.blue[800],
                        borderColor: paletteColors.blue[800],
                    },
                }}
            >
                {formatAppointmentButtonLabel(appointment.startAt)}
            </Button>
            <Popover
                id="appointment-popover"
                open={isOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                slotProps={{ paper: { sx: { p: 2, width: 282 } } }}
            >
                <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={0.5}>
                    <Typography variant="subtitle1" fontWeight="bold">
                        {formatAppointmentPopoverDate(appointment.startAt)}
                    </Typography>
                    <IconButton size="small" onClick={handleClose} sx={{ mt: -0.5, mr: -0.5 }}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>
                <Typography variant="body2">
                    {formatAppointmentTimeRange(appointment.startAt, appointment.endAt)}
                </Typography>
            </Popover>
        </>
    );
}
